import { http } from 'utils'
import { make } from 'vuex-pathify'

export default {
  namespaced: true,

  state: {
    locations: []
  },

  actions: {
    ...make.actions('locations'),

    async getLocations ({ dispatch }) {
      const response = await http.get('garment-locations')

      dispatch('setLocations', response.data.data)

      return response.data.data
    }
  },

  mutations: {
    ...make.mutations('locations')
  }
}
